<script lang="ts" setup>
  import { computed, ref } from 'vue'

  import Dialog from 'primevue/dialog'
  import { AnnouncementService } from '@/services/AnnouncementService'
  import { useConfirm } from 'primevue/useconfirm'
  import ConfirmDialog from 'primevue/confirmdialog'

  import Stepper from 'primevue/stepper'
  import { AnnouncementIcon, NextIcon, PreviosIcon } from '@/config/icons'
  import Step from 'primevue/step'
  import StepPanel from 'primevue/steppanel'
  import ButtonDefault from '@/elements/ButtonDefault.vue'

  const visible = ref(true)

  const svc = AnnouncementService
  const unconfirmed = svc.getUnconfirmed()
  const unconfirmedCount = computed(() => Object.keys(unconfirmed.value).length)
  const hasUnconfirmed = svc.hasUnconfirmed()

  const confirm = useConfirm()

  function doConfirm() {
    confirm.require({
      message: 'Alle Ankündigungen werden als gelesen markiert. Sind Sie sicher?',
      header: 'Bestätigung',

      // rejectClass: 'p-button-secondary p-button-outlined',
      rejectLabel: 'Abbrechen',
      acceptLabel: unconfirmedCount.value > 1 ? 'Alle als gelesen markieren' : 'Als gelesen markieren',
      accept: () => {
        svc.confirmAll()
      },
      reject: () => {
        visible.value = true
      }
    })
  }
</script>

<template>
  <div>
    <template v-if="svc.isReady() && hasUnconfirmed">
      <ConfirmDialog group="positioned" />
      <Dialog
        v-model:visible="visible"
        :closable="false"
        :dismissable="false"
        class="max-h-[85vh] min-w-[95%] max-w-[95%] @md:min-w-[90%] @md:max-w-[90%] h-fit"
        modal
        position="top">
        <template #header>
          <AnnouncementIcon class="flex-0 size-7 inline-block mr-2" />
          <span class="flex-1 text-center font-semibold text-xl px-4">Ankündigungen</span>

          <AnnouncementIcon class="flex-0 size-7 inline-block mr-2 scale-x-flip" />
        </template>
        <template #footer>
          <Button
            class="w-full"
            label="Alle als gelesen markieren"
            size="small"
            @click="doConfirm()" />
        </template>

        <Stepper orientation="vertical">
          <StepItem
            v-for="(a, key, idx) in unconfirmed"
            :key="key"
            :value="idx">
            <Step :pt:number="'text-sm'">
              {{ a.summary }}
            </Step>

            <StepPanel v-slot="x">
              <div class="flex flex-column h-12rem">
                <div
                  class="max-h-[48vh] overflow-y-auto html"
                  v-html="a.content" />
              </div>
              <div class="flex pt-4 justify-content-end gap-x-2">
                <ButtonDefault
                  v-if="idx !== 0 && unconfirmedCount > 1"
                  :icon="PreviosIcon"
                  label="Vorherige"
                  size="extra-small"
                  @click="x.activateCallback(idx - 1)" />
                <ButtonDefault
                  v-if="idx !== Object.keys(unconfirmed).length - 1"
                  :icon="NextIcon"
                  icon-pos="right"
                  label="Nächste"
                  size="extra-small"
                  @click="x.activateCallback(idx + 1)" />
              </div>
            </StepPanel>
          </StepItem>
        </Stepper>
      </Dialog>
    </template>
  </div>
</template>
